import { useFormik } from 'formik';
import React, { useState } from 'react';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { toast } from 'react-toastify';
import moment from 'moment';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { ClipLoader } from 'react-spinners';

const CuttingReportFromToForm = () => {
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            from: null,
            to: null,
        },
        onSubmit: async (values) => {
            console.log('values', values);
            if (!values?.from && !values?.to) {
                toast.error('Please select From and To date');
                return;
            }
            if (values?.from && !values?.to) {
                toast.error('Please also select To date');
                return;
            }
            if (!values?.from && values?.to) {
                toast.error('Please also select From date');
                return;
            }
            const data = {
                fromDate: moment(values?.from).startOf('day').valueOf(),
                endDate: moment(values?.to).endOf('day').valueOf(),
              
            };
            try {
                setLoading(true);
                const response = await authAxiosInstance.post(
                    '/cuttingCard/cuttingReport', data
                );
                const printWindow = window.open('', '_blank');
                printWindow.document.write(response.data);
                setLoading(false);
            } catch (error) {
                console.log('error', error);
                toast.error('Failed to get mill report');
            } finally {
                setLoading(false);
            }
        },
    });
    return (
        <div className="p-4 border rounded-lg">
            <h1 className="font-semibold">Cutting Report</h1>
            <form className="w-full" onSubmit={formik.handleSubmit}>
                <div className="flex flex-row items-center gap-4">
                    <div className="w-full">
                        <FormikInputDateGroup
                            formik={formik}
                            name="from"
                            label="From"
                        />
                    </div>
                    <div className="w-full">
                        <FormikInputDateGroup
                            formik={formik}
                            name="to"
                            label="To"
                        />
                    </div>
                </div>
                <div className="mt-4 flex flex-row items-center gap-4">
                   {loading ? (<ClipLoader />) : <PrimaryButton type="submit">Get Report</PrimaryButton>}
                    <PrimaryButton type="button"
                        onClick={(e)=>{
                            e.stopPropagation();
                            formik.setFieldValue('from','')
                            formik.setFieldValue('to','')
                        }}
                    >Clear</PrimaryButton>
                </div>
            </form>
        </div>
    );
};

export default CuttingReportFromToForm;
